import baseContextComponent from "@/components/baseContextComponent";
import { datiViaggio } from "@/models/carrello/datiViaggio";
import { CarrelloInfoProdotto } from "@/models/carrello/infoProdotto";
import { associaDistributoriPacchettiExtended } from "@/models/carrello/prodotti";
import { CarrelloProdottoSuggerito } from "@/models/carrello/prodottiSuggeriti";
import api from "@/services/api";
import { Component, Watch } from "vue-property-decorator";
import { mapMutations, mapState } from "vuex";

const _ENDPONT_INFO_PRODOTTO = api.endpoint.CARRELLO.INFO_PRODOTTO;

@Component({
	computed: {
		...mapState({
			datiViaggio: (state: any) => state.datiViaggio,
			prodottoSelezionato: (state: any) => state.prodottoSelezionato
		})
	},
	methods: {
		...mapMutations([  "setProdottoSelezionato", "setDatiViaggio"])
	}
})

export default class popupProdottoSuggerito extends baseContextComponent {
	setProdottoSelezionato!: (prodotto: CarrelloInfoProdotto) => void;
	setDatiViaggio!: (datiViaggio: datiViaggio) => void;

	datiViaggio!: datiViaggio;
	// @Watch("$route", { deep: true })
	// onRouteChange(oldValue, newValue) {
	// 	var self = this;

	// 	if ((oldValue || {}).name != (newValue || {}).name && self.$route != null) {
	// 		self.loadPopUp();
	// 	}
	// }
	
	prodottoBase: associaDistributoriPacchettiExtended = null;
	prodottoSuggerito: CarrelloProdottoSuggerito = null;
	
	showModal = false;
	// gestendo l'apertura di un solo messaggio per volta
	// @Watch("showModal")
	// onShowModalChange(oldValue, newValue) {
	// 	var self = this;
	// 	if (self.showModal == false) {
	// 		self.tryOpen();
	// 	}
	// }
	beforeDestroy() {
		this.$root.$off("openPopupProdottoSuggerito");
	}
	mounted() {
		var self = this;

		this.$root.$on("openPopupProdottoSuggerito", dati => { // dati -> {prodottoBase, prodottoSuggerito}
			// salvere qui i dati del prodotto
			self.prodottoBase = dati.prodottoBase;
			self.prodottoSuggerito = dati.prodottoSuggerito;
			self.showModal = true;
		});
	}
	get title(): string {
		return (this.prodottoSuggerito ?? {}).pacchetto ?? "";
	}
	get pathFile(): string {
		//return "";
		return (this.prodottoSuggerito ?? {}).immagine ?? null;
	}
	get descrizione(): string {
		return (this.prodottoSuggerito ?? {}).testo ?? null;
	}
	get titleSecondary(): string {
		return (this.prodottoSuggerito ?? {}).testo ?? null;
	}
	get subTitle(): string {
		return (this.prodottoSuggerito ?? {}).testo ?? null;
	}
	scegliProdottoSuggerito(){
		this.selezionaProdotto(this.prodottoSuggerito.pacchettoID);
	}
	scegliProdottoBase(){
		this.selezionaProdotto(this.prodottoBase.pacchettoID);
	}
	async selezionaProdotto(id: number){
		var res = await api.get(`${_ENDPONT_INFO_PRODOTTO}/${id}`);

		this.setProdottoSelezionato(res);

		var d = new datiViaggio();
		d.pacchettoID = id;
		d.parametri = this.datiViaggio.parametri;

		this.setDatiViaggio(d);
		this.$router.push({ path: "infoProdotto" as string });
		this.close();
	}
	close() {
		this.showModal = false;
	}
}